// @flow

import { type OutgoingPayment } from '../outgoing-payment/types';

export async function multicajaOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {

  return {
    payment_type: 'multicaja',
    payment_type_code: 'multicaja',
  };
}
